import { render, staticRenderFns } from "./dialog-info.vue?vue&type=template&id=08d9af66&scoped=true"
import script from "./dialog-info.vue?vue&type=script&lang=js"
export * from "./dialog-info.vue?vue&type=script&lang=js"
import style0 from "./dialog-info.vue?vue&type=style&index=0&id=08d9af66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9af66",
  null
  
)

export default component.exports